import { render, staticRenderFns } from "./cc-hub-articles.vue?vue&type=template&id=d4f0a2a8&"
import script from "./cc-hub-articles.vue?vue&type=script&lang=js&"
export * from "./cc-hub-articles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports